

import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Promo1 from "../../assets/Images/PromoCards/Promo1.png";
import Promo2 from "../../assets/Images/PromoCards/Promo2.png";
import Promo3 from "../../assets/Images/PromoCards/Promo3.png";
import "./PromoCards.css";
import { FaArrowRightLong } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
  import AOS from 'aos';
import 'aos/dist/aos.css';

const cardStyle = (image) => ({
  backgroundImage: `url(${image})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  color: "white",
  textAlign: "center",
  padding: "40px",
  minHeight: "536px",
  display: "flex",
  flexDirection: "column",
});

const PromoCards = () => {


useEffect(() => {
  AOS.init({ duration: 1000, once: true });
}, []);

  const navigate = useNavigate();

  // Set your sale end time (example: 7 days from now)
  const now = new Date();
const targetDate = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59).getTime();


const [timeLeft, setTimeLeft] = useState({
  days: "00",
  hours: "00",
  minutes: "00",
  seconds: "00",
});

useEffect(() => {
  const now = new Date();
  const targetDate = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59).getTime();

  const interval = setInterval(() => {
    const now = new Date().getTime();
    const distance = targetDate - now;

    if (distance < 0) {
      clearInterval(interval);
      setTimeLeft({
        days: "00",
        hours: "00",
        minutes: "00",
        seconds: "00",
      });
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    setTimeLeft({
      days: String(days).padStart(2, "0"),
      hours: String(hours).padStart(2, "0"),
      minutes: String(minutes).padStart(2, "0"),
      seconds: String(seconds).padStart(2, "0"),
    });
  }, 1000);

  return () => clearInterval(interval);
}, []);


  return (
    <div className="container-fluid mt-5 promo-cards-main-container mb-5">
      <div className="row promo-cards-main-container-row">
        {/* Card 1 - Sale of the Month */}
        <div className="col-12 col-md-6 mx-md-auto col-lg-4 card-sm-bottom-space"
         data-aos="fade-right">
          <div className="card p-4" style={cardStyle(Promo1)}>
            <h6 className="ff-poppins fw-500 fs-14 promo-card-top-heading fc-white">
              BEST DEALS
            </h6>
            <h2 className="ff-poppins fw-600 fs-32 promo-card-top-main-heading fc-white">
              Sale of the Month
            </h2>
            <div className="d-flex justify-content-center gap-3 text-white promo-card-time-div">
              <div className="text-center">
                <h3 className="m-0 ff-poppins fs-18 fw-400">{timeLeft.days}</h3>
                <p className="m-0 ff-poppins fs-12 fw-400 promo-time">DAYS</p>
              </div>
              <span className="fw-400 fs-20 ff-poppins promo-colon">:</span>
              <div className="text-center">
                <h3 className="m-0 ff-poppins fs-18 fw-400">{timeLeft.hours}</h3>
                <p className="m-0 ff-poppins fs-12 fw-400 promo-time">HOURS</p>
              </div>
              <span className="fw-400 fs-20 ff-poppins promo-colon">:</span>
              <div className="text-center">
                <h3 className="m-0 ff-poppins fs-18 fw-400">{timeLeft.minutes}</h3>
                <p className="m-0 ff-poppins fs-12 fw-400 promo-time">MINS</p>
              </div>
              <span className="fw-400 fs-20 ff-poppins promo-colon">:</span>
              <div className="text-center">
                <h3 className="m-0 ff-poppins fs-18 fw-400">{timeLeft.seconds}</h3>
                <p className="m-0 ff-poppins fs-12 fw-400 promo-time">SECS</p>
              </div>
            </div>
            <div className="promo-shop-btn-div">
              <button
                className="ff-poppins fw-600 fs-14 btn btn-light promo-shop-now-btn fc-green  mt-3"
                onClick={() => navigate("/shop")}
              >
                Shop Now{" "}
                <span className="fc-green" style={{ paddingLeft: "5px" }}>
                  <FaArrowRightLong />
                </span>
              </button>
            </div>
          </div>
        </div>

        {/* Card 2 */}
        <div className="col-12 col-md-6 mx-md-auto col-lg-4 card-sm-bottom-space"
         data-aos="zoom-in">
          <div className="card p-4" style={cardStyle(Promo2)}>
            <h6 className="ff-poppins fw-500 fs-14 promo-card-top-heading fc-white">
              85% FAT FREE
            </h6>
            <h2 className="ff-poppins fw-600 fs-32 promo-card-top-main-heading fc-white">
              Low-Fat Meat
            </h2>
            <p className="ff-poppins fw-400 fs-18">
              Starting at{" "}
              <span
                className="ff-poppins fw-600 fs-18"
                style={{ color: "#FF8A00" }}
              >
                Ksh 79.99
              </span>
            </p>
            <div className="promo-shop-btn-div">
              <button
                className="ff-poppins fw-600 fs-14 btn btn-light promo-shop-now-btn fc-green mt-5"
                onClick={() => navigate("/shop")}
              >
                Shop Now{" "}
                <span className="fc-green" style={{ paddingLeft: "5px" }}>
                  <FaArrowRightLong />
                </span>
              </button>
            </div>
          </div>
        </div>

        {/* Card 3 */}
        <div className="col-12 col-md-6 mx-md-auto col-lg-4 card-sm-bottom-space"
          data-aos="fade-left">
          <div className="card p-4" style={cardStyle(Promo3)}>
            <h6 className="ff-poppins fw-500 fs-14 promo-card-top-heading fc-white">
              SUMMER SALE
            </h6>
            <h2 className="ff-poppins fw-600 fs-32 promo-card-top-main-heading fc-promo-3">
              100% Fresh Fruit
            </h2>
            <p className="ff-poppins fw-400 fs-18 promo-card-3-upto">
              Up to{" "}
              <span className="fs-18 fw-600 badge bg-dark promo-card-3-upto-badge">
                64% OFF
              </span>
            </p>
            <div className="promo-shop-btn-div">
              <button
                className="ff-poppins fw-600 fs-14 btn btn-light promo-shop-now-btn fc-green  mt-5"
                onClick={() => navigate("/shop")}
              >
                Shop Now{" "}
                <span className="fc-green" style={{ paddingLeft: "5px" }}>
                  <FaArrowRightLong />
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromoCards;
